import React from "react";
import Layout from "./layout";
const InnerLayout = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode[] | React.ReactNode;
}) => {
  return (
    <Layout>
      <></>
      <div className="bg-gradient-to-r from-yellow-50 to-yellow-200 pt-32">
        <div className="w-full max-w-screen-xl mx-auto p-10 text-pink-600">
          <h1 className="text-3xl font-light">{title}</h1>
        </div>
      </div>
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 min-h-screen">
        <div className="min-h-screen w-full bg-gray-50 max-w-screen-xl mx-auto p-10 shadow-lg">
          {children}
        </div>
      </div>
    </Layout>
  );
};

export default InnerLayout;
